import { StopOutlined } from "@ant-design/icons";
import { Button, Modal, Popconfirm } from "antd";
import { AxiosInstance } from "axios";
import { FunctionComponent, useCallback } from "react";
import { useStateIfMounted } from "use-state-if-mounted";

interface RejectBtnProps {
  path: string;
  onDone?: () => void;
  httpClient: AxiosInstance;
  disabled?: boolean;
}

const RejectBtn: FunctionComponent<RejectBtnProps> = ({
  path,
  onDone,
  httpClient,
  disabled,
}) => {
  const [busy, setBusy] = useStateIfMounted(false);
  const process = useCallback(async () => {
    const reason = prompt("Please enter the reason");
    if (!reason) {
      return;
    }
    setBusy(true);
    try {
      await httpClient.post(path, { reason });
      onDone && onDone();
      Modal.success({
        title: "Success!",
        content: "User has been rejected!",
      });
    } catch (e) {
      Modal.error({
        title: "Ops!",
        content: "Something went wrong!",
      });
    }
    setBusy(false);
  }, [path, onDone]);
  return (
    <Popconfirm
      title="Are you sure?"
      onConfirm={process}
      okButtonProps={{ loading: busy }}
    >
      <Button
        danger
        size="small"
        disabled={busy || disabled}
        icon={<StopOutlined />}
      >
        Reject
      </Button>
    </Popconfirm>
  );
};

export default RejectBtn;
